import { useState } from "react";
import { Globe } from "lucide-react";
import { navigationItems } from "@/constants/index";
import { Tab } from "./tab";
import { Cursor } from "./cursor";
import { Sidebar } from "./sidebar/sidebar";
import { useNavigationStore } from "@/stores/navigationStore";
import type { Position } from "./types";
import LiquidGlass from "liquid-glass-react";

export function NavBar() {
  const [position, setPosition] = useState<Position>({
    left: 0,
    width: 0,
    opacity: 0,
  });

  // Get active navigation item using optimized selector
  const activeNavigationItem = useNavigationStore((state) =>
    state.getActiveNavigationItem(),
  );

  return (
    <>
      {/* Desktop Navigation - Hidden on mobile, visible on md+ */}

      <LiquidGlass
        displacementScale={64}
  blurAmount={0.1}
  saturation={130}
  aberrationIntensity={2}
  elasticity={0}
  cornerRadius={100}
        padding="8px 0px"
        // className="fixed top-7 left-1/2 -translate-x-1/2 z-50 hidden md:block"
        // mode="polar"
        // style={{ position: "fixed", top: "15px", left: "50%" }}
        style={{
          position: "fixed",
          top: "40px", // top-7 = 1.75rem (7 * 0.25rem)
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 50,
          // display: "none", // hidden = display: none
        }}
      >
        <ul
          onMouseLeave={() => {
            setPosition((pv) => ({
              ...pv,
              opacity: 0,
            }));
          }}
          className="rounded-full flex items-center justify-center gap-2 px-2 py-2 relative"
        >
          {navigationItems.map((item) => (
            <Tab
              key={item.name}
              setPosition={setPosition}
              href={item.link}
              isActive={activeNavigationItem === item.name}
            >
              {item.name === "Contact" && <Globe className="w-4 h-4" />}
              {item.name}
            </Tab>
          ))}

          <Cursor position={position} />
        </ul>
      </LiquidGlass>

      <Sidebar />
    </>
  );
}
